import { arbitrumSepolia } from 'thirdweb/chains'
import { NetworkEnvironment } from '../types'

export const arbitrumSepoliaEnvironment: NetworkEnvironment = {
  subgraphUrls: {
    main: 'https://api.studio.thegraph.com/query/40769/swarmx-arbitrum-sepolia-v2/v0.1.6',
    sx1155:
      'https://api.studio.thegraph.com/query/40769/swarmx-arbitrum-sepolia/v0.0.23',
    swarm:
      'https://api.studio.thegraph.com/query/40769/trade-arbitrum-sepolia/version/latest',
  },
  contracts: {
    dotcContractAddress: '0x8352819830D8e7aC9Ad47e981De76D0085747253',
    dotcEscrowContractAddress: '0x87bf586BB01c161e0d2c1C09ccC8A790de4ddcAC',
    smtDistributorAddress: '',
    goldBundleAddress: '0x066157Dc143B12645e2853D1969Ef7493C8a6796',
    goldBundleStorageAddress: '0x41D9DEcE2CCA550270D6C4acAF15a9b79791eaD4',
  },
  tokens: {
    smt: '0xFa1EDF1A0cEB62Db77c13da2DA99f17a81760D22',
    xGold: '0x066157Dc143B12645e2853D1969Ef7493C8a6796',
    goldOz: '0x862ead81f034bfe80fc8d35b7496ba9d5bf9d044',
    goldKg: '0x3d0c3da469d3f73d51e263acbb04c58d246841ea',
  },
}

export const arbitrumSepoliaChainConfig = arbitrumSepolia
